/**
 * Aurora — Flowing color gradient background.
 * Inspired by React Bits Aurora component.
 * Pure CSS animation, zero dependencies.
 */
export default function Aurora({ className = "", colors, speed = 6 }) {
  const defaultColors = ["#6366f1", "#a855f7", "#06b6d4", "#ec4899"];
  const c = colors || defaultColors;

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {c.map((color, i) => (
        <div
          key={i}
          className="absolute rounded-full opacity-30 blur-[120px] will-change-transform"
          style={{
            width: `${50 + i * 15}%`,
            height: `${50 + i * 15}%`,
            background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
            left: `${10 + (i * 25) % 80}%`,
            top: `${10 + (i * 20) % 60}%`,
            animation: `aurora-float-${i} ${speed + i * 2}s ease-in-out infinite alternate`,
          }}
        />
      ))}
      <style>{`
        @keyframes aurora-float-0 {
          0% { transform: translate(0%, 0%) scale(1); }
          100% { transform: translate(15%, -10%) scale(1.15); }
        }
        @keyframes aurora-float-1 {
          0% { transform: translate(0%, 0%) scale(1); }
          100% { transform: translate(-20%, 15%) scale(1.1); }
        }
        @keyframes aurora-float-2 {
          0% { transform: translate(0%, 0%) scale(1); }
          100% { transform: translate(10%, 20%) scale(1.2); }
        }
        @keyframes aurora-float-3 {
          0% { transform: translate(0%, 0%) scale(1); }
          100% { transform: translate(-15%, -15%) scale(1.05); }
        }
      `}</style>
    </div>
  );
}
